export { Slider } from './Slider'
export type { SliderProps } from './Slider.types'
